import React, { useState, useEffect, useContext } from 'react';
import axios from '@common/axios';
import { Card, Alert } from 'antd';
import CircularLoader from '@common/CircularLoader';
import MathJaxHTMLContent from "@common/MathJaxHTMLContent";
import { BrandContext } from "@context/BrandContext";

const WalkthroughActivities = ({ step }) => {
    const brandConfig = useContext(BrandContext);
    const [isLoading, setLoading] = useState(true);
    const [questions, setQuestions] = useState();
    const [error, setError] = useState();

    const loadWalkthroughActivities = async () => {
        setLoading(true);
        try {
            const response = await axios.get('/web/ui/trail/step/activities/user', {
                params: { pathwayUserId: step.pathwayUserId, stepId: step.stepId },
            });

            const resultMap = {};
            (response.data.questionResults || []).forEach(result => {
                resultMap[result.questionId] = result;
            });

            setQuestions(response.data);
            setError(undefined);
        } catch (err) {
            console.error('Error loading custom activity:', err);
            setError('Failed to load activity. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!step) {
            setQuestions(undefined);
            setLoading(false);
            return;
        }
        loadWalkthroughActivities();
    }, [step]);

    if (isLoading) return <CircularLoader />;
    if (error) return <Alert showIcon={true} message={error} type="error" role="alert" />;
    if (!questions) return <Alert showIcon={true} message="Questions not found" type="error" role="alert" />;

    return (
        <section className="ch-trail-walkthrough-activities">
            {questions.map((question, index) => {
                return (
                    <Card key={question.questionId} style={{ marginBottom: 'var(--spacing-unit)'}}>
                        <div className="activity-card-content flexRow flexAlignStart">
                            <svg className="ch-icon-large" viewBox="0 0 128 128" aria-hidden="true" focusable="false">
                                <use href="#tasks-icon" />
                            </svg>
                            <div className="flexColumn" style={{ marginLeft: '16px' }}>
                                <h3>{brandConfig.walkthroughName} {index + 1}</h3>
                                <MathJaxHTMLContent html={question.description || ''} showLoader={false} />
                            </div>
                        </div>
                    </Card>
                );
            })}
        </section>
    );
};

export default WalkthroughActivities;
